import Formatter from "../../../../../class/Formatter";
import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'unit_measure',
      label: i18n.t('labor.unit_of_measure'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'conversion_factor',
      label: i18n.t('common_words.conversion_factor'),
      minWidth: 100,
      sortable: true,
      align: 'center',
      formatter: (row, column) => {
        return Formatter.formatMoney(parseFloat(row[column.property]))
      },
    }
  ];

  return { Table };
};

export default configTable;